import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']

  append (event) {
    const text = event.currentTarget.textContent.trim()
    this.inputTarget.value += text
    this.inputTarget.focus()
  }
}
